/* Copyright (c) 2018-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { Logger, LoggingService } from '../logging/logging.service';
import { WindowConfig } from './window.config';

@Injectable({
    providedIn: 'root'
})
export class WindowService {
    private logger: Logger;
    private windowRef: any;

    constructor(loggingService: LoggingService, config: WindowConfig) {
        this.logger = loggingService.getLogger('crimson/windowService');
        this.windowRef = window || {};
        // more things to be added to config later
        this.windowRef.name = config.name;
    }

    get window(): Window {
        return this.windowRef;
    }

    getFocusEvent(): Observable<Event> {
        return fromEvent(window, 'focus');
    }

    getPageShowEvent(): Observable<PageTransitionEvent> {
        return fromEvent(window, 'pageshow') as Observable<PageTransitionEvent>;
    }

    getBeforeUnloadEvent(): Observable<Event> {
        return fromEvent(window, 'beforeunload') as Observable<Event>;
    }

    /**
     * @note to avoid unnecessary change detection, consider `pipe` or `subscribe` outside Angular zone.
     */
    getKeydownEvent(): Observable<KeyboardEvent> {
        return fromEvent(window, 'keydown') as Observable<KeyboardEvent>;
    }

    /**
     * @note to avoid unnecessary change detection, consider `pipe` or `subscribe` outside Angular zone.
     */
    getKeyupEvent(): Observable<KeyboardEvent> {
        return fromEvent(window, 'keyup') as Observable<KeyboardEvent>;
    }
}
